var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginAltS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "71px",
    viewBox: "0 0 58 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "login-alt-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login-alt-S",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,59.2082386 L6.18332344,37.49994 L51.4624177,37.49994 L57.6707411,59.2499052 C50.1874197,66.4165604 40.024936,70.83322 28.8416205,70.83322 C17.6541384,70.83322 7.48748802,66.4165604 0,59.2082386 Z M28.8416205,0 C35.7416095,0 41.3416005,5.5833244 41.3416005,12.49998 C41.3416005,19.4166356 35.7416095,24.99996 28.8416205,24.99996 C21.9416316,24.99996 16.3416405,19.4166356 16.3416405,12.49998 C16.3416405,5.5833244 21.9416316,0 28.8416205,0 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAltS);
export default __webpack_public_path__ + "static/media/login-alt-S.aa7e74e3a3aa76f21300fdf59fb49e4e.svg";
export { ForwardRef as ReactComponent };